import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_REQUEST,
  USER_TYPE,
  UPDATE_USER_TYPE,
} from "../actions/action-type";

const initalState = {
  loginResponse: null,
  isLoginLoading: false,
  isLoginError: false,
  isLoginSuccess: false,
  userType: {},
};

const userReducer = (state = initalState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isLoginLoading: true,
        isLoginError: false,
        isLoginSuccess: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loginResponse: action.payload,
        isLoginLoading: false,
        isLoginSuccess: true,
      };
    case LOGIN_ERROR:
      return {
        ...state,
        isLoginLoading: false,
        isLoginError: true,
        isLoginSuccess: false,
      };
    case USER_TYPE:
      return { ...state, userType: action.payload };
    case UPDATE_USER_TYPE:
      return { 
        ...state, 
        userType: {
          ...state.userType,
          accessToken: action.payload.accessToken,
          expiresIn: action.payload.expiresIn,
          refreshToken: action.payload.refreshToken,
          tokenType: action.payload.tokenType
        }
      };
    case LOGOUT_REQUEST:
      return initalState;
    default:
      return state;
  }
};

export default userReducer;
